module.exports = __webpack_public_path__ + "static/media/Roboto-Light.fc84e998.ttf";